import {Component} from '@angular/core';
import {FormControl} from '@angular/forms';
/**
 * \@title Simple autocomplete
 */
export class AutocompleteSimpleExample {

  myControl: FormControl = new FormControl();

  options = [
    'One',
    'Two',
    'Three'
   ];

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'autocomplete-simple-example',
  templateUrl: 'autocomplete-simple-example.html',
  styleUrls: ['autocomplete-simple-example.css']
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AutocompleteSimpleExample_tsickle_Closure_declarations() {
/** @type {?} */
AutocompleteSimpleExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AutocompleteSimpleExample.ctorParameters;
/** @type {?} */
AutocompleteSimpleExample.prototype.myControl;
/** @type {?} */
AutocompleteSimpleExample.prototype.options;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
